<template>
    <v-container class="d-flex justify-center align-center" style="height: 100vh;">
      <v-card class="pa-5" width="400">
        <v-card-title class="text-h5 text-center">Reset Password</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="handleReset">
            <v-text-field
              v-model="newPassword"
              label="New Password"
              type="password"
              outlined
              dense
              required
            ></v-text-field>
            <v-text-field
              v-model="confirmPassword"
              label="Confirm Password"
              type="password"
              outlined
              dense
              required
            ></v-text-field>
            <v-btn color="primary" block class="mt-4" @click="handleReset">
              Reset Password
            </v-btn>
            <v-alert v-if="error" type="error" dense class="mt-3">
              {{ error }}
            </v-alert>
            <v-alert v-if="success" type="success" dense class="mt-3">
              {{ success }}
            </v-alert>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </template>

  <script>
import api from "@/plugins/axios";
  export default {
    name: 'ResetPassword',
    data() {
      return {
        newPassword: '',
        confirmPassword: '',
        error: null,
        success: null,
      };
    },
    methods: {
      async handleReset() {
        // Check if passwords match
        if (this.newPassword !== this.confirmPassword) {
          this.error = 'Passwords do not match';
          return;
        }

        // Get token from URL params
        const token = this.$route.params.token;

        try {
          // Make API call to reset the password
          await api.post(`/api/reset-password/${token}/`, {
            new_password: this.newPassword,
          });
          this.success = 'Password reset successfully. Redirecting to login...';


          setTimeout(() => {
            this.$router.push('/login');
          }, 2000);
        } catch (err) {
          this.error =
            err.response && err.response.data && err.response.data.error
              ? err.response.data.error
              : 'An error occurred. Please try again.';
        }
      },
    },
  };
  </script>
